export const ROUTES_DIRECTORY = `.cache/page-ssr/routes/`
